import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { fetchApiDataDup } from "../../../../redux/reducers/commonApiSlice";
import SearchNButtons from "../../../common-components/SearchNButtons";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";
import { total_pt_sale_details } from "../../../../data/ApiEndpoints";
import {
  convertStraight,
  convertThenFormat,
  formatDateTimezon,
} from "../../../common-data/Converts";
import PayoutsTable from "../../../components-bootstrap/PayoutsTable";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";
import PartialDetailsMobile from "../PartialDetailsMobile";
import PTSaleDetailsMobile from "./PTSaleDetailsMobile";

const PTSaleDetails = ({ userInfoData, rowData, onCloseModal }) => {
  const dispatch = useDispatch();
  const { loadingDup, dataDup, errorDup } = useSelector(
    (state) => state.common
  );

  const iniAllDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniAllDatas);
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    subscription_id: rowData?.subscription_id || "",
    trainer_id: rowData?.trainer_id || "",
    month: rowData?.purchase_month || "",
    year: rowData?.purchase_year || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
    payment_details: [],
  };
  const [modValues, setModValues] = useState(iniModvalues);

  function getDetails(filters) {
    dispatch(
      fetchApiDataDup({
        method: "GET",
        endpoint: total_pt_sale_details,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
      setIsPage(0);
    }
  };

  useEffect(() => {
    if (filters.subscription_id) {
      getDetails(filters);
    }
  }, [filters]);

  useEffect(() => {
    if (
      dataDup?.status &&
      dataDup?.data?.length > 0 &&
      !loadingDup &&
      !errorDup
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: dataDup.data,
        pagination: dataDup?.pagination?.length > 0 ? dataDup.pagination : [],
      }));
    } else {
      setAllDatas(iniAllDatas);
    }
  }, [dataDup, loadingDup, errorDup]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const tbColumn = [
    {
      dataField: "user_id",
      text: "member detail",
      formatter: (cell, row) => (
        <span className="tb-data minWidth100">
          {row?.user_name || "NA"}
          <br />
          <small className="lowercase">
            {row?.user_mobile || ""}
            <br />
            {row?.user_email || ""}
          </small>
        </span>
      ),
    },
    {
      dataField: "is_partial",
      text: "payment type",
      formatter: (cell, row) => (
        <span
          className={`tb-data ${row?.is_partial ? "link" : ""}`}
          onClick={() =>
            row?.is_partial &&
            setModValues((prevs) => ({
              ...prevs,
              isModOpen: true,
              cardName: "partial_details",
              partialDetails: row?.payment_details || [],
            }))
          }
        >
          {row?.is_partial ? "Partial" : "Full"}
        </span>
      ),
    },
    {
      dataField: "plan_price",
      text: "plan price",
      formatter: (cell, row) => (
        <span className="tb-data">
          ₹{convertThenFormat(row?.plan_price || 0)}
        </span>
      ),
    },
    {
      dataField: "total_price",
      text: "total amount paid during purchase",
      formatter: (cell, row) => (
        <span className="tb-data">
          ₹{convertThenFormat(row?.total_price || 0)}
        </span>
      ),
    },
    {
      dataField: "total_full_price",
      text: "full price",
      formatter: (cell, row) => (
        <span className="tb-data">
          ₹{convertThenFormat(row?.total_full_price || 0)}
        </span>
      ),
    },
    {
      dataField: "total_partial_price",
      text: "partial price",
      formatter: (cell, row) => (
        <span className="tb-data">
          ₹{convertThenFormat(row?.total_partial_price || 0)}
        </span>
      ),
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (cell, row) => (
        <span className="tb-data minWidth100">
          {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
        </span>
      ),
    },
    {
      dataField: "start_date",
      text: "start/expire date",
      formatter: (cell, row) => (
        <span className="tb-data minWidth150">
          <small>
            {row?.start_date ? formatDateTimezon(row.start_date) : "-"}/
            {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
          </small>
        </span>
      ),
    },
    {
      dataField: "subscription_status",
      text: "subscription status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background:
                row?.subscription_status === "active" ? "#0A701B" : "#D90000",
              color: "#fff",
            }}
          >
            {row?.subscription_status || "NA"}
          </span>
        );
      },
    },
  ];

  const pmInfoColumns = [
    {
      dataField: "payment_created",
      text: "Payment Created",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.payment_created
              ? formatDateTimezon(row.payment_created)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "Schedule Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.amount || 0) || 0}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background:
                row?.status === "pending"
                  ? "#FFEDC0"
                  : row?.status === "completed"
                  ? "#B4E7B9"
                  : "#F3DADA",
              color:
                row?.status === "pending"
                  ? "#171717"
                  : row?.status === "completed"
                  ? "#0A701B"
                  : "#D90000",
              borderRadius: "10px",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={() => setModValues(iniModvalues)}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.cardName === "partial_details" ? "mod-width-50p" : ""
          }`}
        >
          <ModalHeadAndClose
            title={modValues.cardName?.replace(/_/g, " ")}
            onClose={() => setModValues(iniModvalues)}
          />

          {modValues.cardName === "partial_details" ? (
            <>
              <div className="fullWidthFlexCenter separatedTable hideMobile">
                <PayoutsTable
                  dataValues={modValues.partialDetails}
                  columnsValues={pmInfoColumns}
                />
              </div>

              <div className="lead-logs-card-container only-mobile">
                <PartialDetailsMobile tableData={modValues.partialDetails} />
              </div>
            </>
          ) : null}
        </div>
      </Modal>

      <div className="modalHeadAndCloseContainer mod-with-details">
        <div className="user-info">
          <div className="user-details">
            <span className="mod-header">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
                onClick={onCloseModal}
              >
                <g id="navigate_before">
                  <path
                    id="icon"
                    d="M19.25 24.75L11 16.5L19.25 8.25L21.175 10.175L14.85 16.5L21.175 22.825L19.25 24.75Z"
                    fill="#1D1B20"
                  />
                </g>
              </svg>{" "}
              {rowData?.trainer_name || "NA"} (Trainer)
            </span>
            <span className="mod-regular-text underline">
              +91 {rowData?.trainer_mobile || ""}
            </span>
            <span className="mod-regular-text lowercase underline">
              {rowData?.trainer_email || ""}
            </span>
            <span className="mod-light-text">{rowData?.gym_name || ""}</span>
            <span className="mod-light-text">
              purchase month/year - {rowData?.purchase_month || ""}/
              {rowData?.purchase_year || ""}
            </span>
          </div>
        </div>

        <button
          type="button"
          className="closeModalBtn hideMobile"
          onClick={onCloseModal}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-x-lg"
            viewBox="0 0 16 16"
          >
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
          </svg>
        </button>
      </div>

      <SearchNButtons
        filters={allFilters}
        setFilters={setAllFilters}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
      />

      {loadingDup ? (
        <ReactVortoxSpinner />
      ) : (
        <>
          <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table hideMobile mt30">
            <PaymentLinkTable
              tableData={allDatas.allData}
              tableColumns={tbColumn}
              tablePagination={allDatas.pagination}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          </div>

          <div className="lead-logs-card-container only-mobile">
            <PTSaleDetailsMobile
              tableData={allDatas.allData}
              tablePagination={allDatas.pagination}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
            />
          </div>
        </>
      )}
    </>
  );
};

export default PTSaleDetails;
